<template>
    <div>
        <h2>Formulaire utilisateur</h2>
        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="name_user" class="form-label fw-bold">Nom*</label>
                <input type="text" class="form-control" id="name_user" placeholder="Nom" v-model="formData.name"
                    required>
                <small class="text-danger" v-if="errors['name']">{{ errors['name'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="prenoms_user" class="form-label fw-bold">Prenoms</label>
                <input type="text" class="form-control" id="prenoms_user" placeholder="Prénoms"
                    v-model="formData.prenoms" required>
                <small class="text-danger" v-if="errors['prenoms']">{{ errors['prenoms'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6" v-if="!isEdit">
                <label for="telephone_user" class="form-label fw-bold">Téléphone*</label>
                <input type="text" class="form-control" id="telephone_user" placeholder="Téléphone"
                    v-model="formData.telephone" required>
                <small class="text-danger" v-if="errors['telephone']">{{ errors['telephone'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="email_user" class="form-label fw-bold">Email*</label>
                <input type="text" class="form-control" id="email_user" placeholder="Email" v-model="formData.email"
                    required>
                <small class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="adresse_user" class="form-label fw-bold">Adresse*</label>
                <input type="text" class="form-control" id="adresse_user" placeholder="Adresse"
                    v-model="formData.adresse" required>
                <small class="text-danger" v-if="errors['adresse']">{{ errors['adresse'][0] }}</small>
            </div>
        </div>
        <div class="row">
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" @click="save">Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
    name: "UserForm",
    mixins: [formMixin],
    props: {
        user_id: {
            type: [String, Number],
            required: true
        }
    },
    data: () => ({
        url: "users",
    }),


}
</script>